import React from "react";
import "../all css/logosofunivercity.css";
const logos1 = require("../../assets/logo/newlogo/alberta.png");
const logos2 = require("../../assets/logo/newlogo/American univercity dubai.png");
const logos3 = require("../../assets/logo/newlogo/berkeley.png");
const logos4 = require("../../assets/logo/newlogo/sydney.png");
const logos5 = require("../../assets/logo/newlogo/heidelberg.png");
const logos6 = require("../../assets/logo/newlogo/McGrill.png");
const logos7 = require("../../assets/logo/newlogo/melborne.png");
const logos8 = require("../../assets/logo/newlogo/queensland.png");
const logos9 = require("../../assets/logo/newlogo/stanford.png");
const logos10 = require("../../assets/logo/newlogo/UCL.png");
const logos11 = require("../../assets/logo/newlogo/University of Edinburgh.png");
const logos12 = require("../../assets/logo/newlogo/UniversityofBritishColumbia 1.png");

const allLogosPhoto = [
  {
    logoName: logos1,
  },
  {
    logoName: logos2,
  },
  {
    logoName: logos3,
  },
  {
    logoName: logos4,
  },
  {
    logoName: logos5,
  },
  {
    logoName: logos6,
  },
  {
    logoName: logos7,
  },
  {
    logoName: logos8,
  },
  {
    logoName: logos9,
  },
  {
    logoName: logos10,
  },
  {
    logoName: logos11,
  },
  {
    logoName: logos12,
  },
];

function LogosOfUnivercity(props) {
  return (
    <div className="logos_main_container">
      <div className="study_destination_title_sub_container">
        <p
          className="title_text wow pulse animated"
          data-wow-delay="500ms"
          data-wow-iteration="infinite"
          data-wow-duration="1s"
        >
          FEATURED UNIVERSITIES
        </p>
      </div>
      <div className="logos_all_box_contianer">
        {allLogosPhoto.map((perLogo) => {
          return (
            <div className="each_box_contianer" key={Math.random()}>
              <div className="img_logo_container">
                <img src={perLogo.logoName} alt="logo" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LogosOfUnivercity;
